import { makeAutoObservable } from 'mobx';

import { CustomGradeCode } from '@/customGrading/constants/customGradeCodes';
import { ProductId } from '@/product/entity/Product';

export type GradeDictEntryId = number;

export interface GradeDictEntryModel {
  id: GradeDictEntryId;
  refId: Nullable<ProductId>;
  title: string;
  parent: Nullable<number>;
}

export default class GradeDictEntry {
  id!: GradeDictEntryId;

  refId: Nullable<ProductId> = null;

  title: string;

  parent: Nullable<number> = null;

  cellWidth = 0;

  cellOffset = 0;

  code: CustomGradeCode;

  constructor({ id, refId, title, parent }: GradeDictEntryModel, code: CustomGradeCode) {
    makeAutoObservable(this, {
      id: false,
    });

    this.id = id;
    this.refId = refId;
    this.title = title;
    this.parent = parent;

    this.code = code;
  }

  get group() {
    return this.isSubgrade ? this.title.replace(/[^a-zA-Z]/g, '') : this.title;
  }

  get isSubgrade() {
    return !!this.parent;
  }

  get label() {
    return this.title;
  }

  setWidth = (cellWidth: number) => {
    this.cellWidth = cellWidth;
  };

  setOffset = (cellOffset: number) => {
    this.cellOffset = cellOffset;
  };
}
